import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import environment from "web/script/modules/environment";
import style from "./burger-menu-item.css";

function BurgerMenuItem({ renderText, renderChevron, href, onClickEvent }) {
    const iconName = environment.getFeature("rebrand_2020") ? "arrow-icon" : "chevron";
    return (
        <li className={style.menuItem}>
            <a className={style.menuItemContent} href={href} onClick={onClickEvent}>
                {renderText}
                {renderChevron && <SVGIcon className={style.menuItemChevron} name={iconName} />}
            </a>
        </li>
    );
}

export default BurgerMenuItem;

BurgerMenuItem.propTypes = {
    renderText: PropTypes.string.isRequired,
    renderChevron: PropTypes.bool,
    href: PropTypes.string,
    onClickEvent: PropTypes.func,
};

BurgerMenuItem.defaultProps = {
    renderText: "",
    renderChevron: false,
    href: null,
};
